module.exports = __webpack_public_path__ + "static/img/1.ce2c7975.png";